(() => {
  const initExclusiveAccordions = (root = document) => {
    root.querySelectorAll('.template-product .product__info-container').forEach((container) => {
      if (container.dataset.jalaneAccordionBound === 'true') return;
      container.dataset.jalaneAccordionBound = 'true';

      container.addEventListener(
        'toggle',
        (event) => {
          const details = event.target;
          if (!(details instanceof HTMLDetailsElement) || !details.open) return;
          if (!details.closest('.product__accordion')) return;

          container.querySelectorAll('.product__accordion details[open]').forEach((other) => {
            if (other !== details) other.open = false;
          });
        },
        true
      );
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initExclusiveAccordions(), { once: true });
  } else {
    initExclusiveAccordions();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initExclusiveAccordions(event.target);
  });
})();
